import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image';

const Banner = () => {
    const data = useStaticQuery(graphql`
    query PhotoQuery {
        perfil: file(relativePath: {eq: "perfil.jpeg"}) {
          childImageSharp {
            fluid(quality: 90) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
        logo: file(relativePath: {eq: "logo_principal.png"}) {
            childImageSharp {
                fixed (width: 280, quality:100){
                    ...GatsbyImageSharpFixed
                }
            }
          }
      }`
    )
    return (
        <section className="major banner">
            <div className="inner">
                <div className="row">
                    <div className="col-md">
                        <Img
                            fluid={data.perfil.childImageSharp.fluid}
                            alt="Photo"
                            className="image-fluid"
                        />
                    </div>
                    <div className="col-md">
                        <div className="content">
                            <Img
                                fixed={data.logo.childImageSharp.fixed}
                                alt="LogoRN"
                                style={{ marginTop: '0.625em' }}
                            />
                            <div className="ml-4">
                                <h3 className="pf"><i>Content Creator.</i></h3>
                                <p>Advogada de formação, criativa por opção. A literatura e a escrita sempre foram companheiras minhas e é com elas que decidi continuar minha jornada profissional.</p>
                                <p>Hoje, como produtora de conteúdo, trabalho para que meus clientes se comuniquem de forma mais humana e eficaz com seu público.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Banner
